<template>
    <div class="lightboxWrapper" v-if="show">
        <div class="lightboxBackdrop" @click.capture.prevent="closeLightbox()"></div>
        <a class="lightboxLink" :href="item.link_url" target="_blank">
            <div id="lightboxImage" class="lightboxImage" :style="imageStyleObject"></div>
        </a>
        <div class="lightboxClose glyphicon glyphicon-remove" @click.capture.prevent="closeLightbox()"></div>
    </div>
</template>

<script>
  //import cookies from '../utils/cookies.js';
  export default {
    name: "Lightbox",
    props: {
      item: {
        type: Object,
        required: true,
        default: () => ({}),
      },
      assetHost: {
        type: String,
        required: true,
        default: () => (''),
      },
      displayedCount: {
        type: Number,
        required: true,
        default: () => (0),
      },
      initShow: {
        type: Number,
        required: false,
        default: () => (0),
      }
    },
    data() {
      return {
        show: this.initShow,

      };
    },
    computed: {
      imageStyleObject: function () {
        if (typeof this.item !== 'undefined' && typeof this.item.image_url !== 'undefined') {
          return {
            display: 'block',
            backgroundImage: 'url(' + this.assetHost + this.item.image_url + ')',
            height:'500px',
            width:'750px'
          };
        } else {
          return { display: 'none' };
        }
      },
      showLightbox(){
        this.show = true;
        this.$emit('incrementDisplayCount');
      },
      maxDisplayCount() {
        return parseInt(this.item.maxPopupCount);
      }
    },
    methods:{
      closeLightbox(){
        this.show = false;
      }
    },
    watch: {
      item: function() {
        if (this.item.pouncingPopup == "1") {
          let maxDisplayCount = parseInt(this.item.maxPopupCount);
          if (maxDisplayCount > this.displayedCount) {
            this.showLightbox();
          }
        }
      }
    },

  }

</script>

<style>
    .lightboxWrapper {
        position: fixed;
        top: 0px;
        left: 0px;
        height: 100%;
        width: 100%;
        z-index: 200;
    }
    .lightboxGradeGuideImage {position: absolute;}
    .lightboxWrapper .lightboxBackdrop {
        height: 100%;
        background-color: #000;
        opacity: .9;
    }
    .lightboxWrapper .lightboxImage {
        background: url('') no-repeat center center;
        background-size: contain;
        left:50%;
        max-width: 100%;
        max-height: 100%;
        position: fixed;
        top:50%;
        transform: translate(-50%, -50%);
    }
    .lightboxWrapper.lightboxGradeGuideImage .lightboxImage {position: absolute;}

    .lightboxWrapper .lightboxClose {
        height: 30px;
        width: 30px;
        background-color: #444;
        cursor: pointer;
        display: inline-block;
        position: absolute;
        top: 10px;
        right: 10px;
        font-size: 20px;
        border-radius: 30px;
        padding: 3px;
        border: 2px solid #eee;
        color: #eee;
    }

</style>